module.exports = __webpack_public_path__ + "img/yzm4.c199d91f.png";